(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vaja-testimonial"] && !Shopify.designMode) return;
  try {
    
  /*
   * <vaja-reviews>: switch reviews with the indicator, swipe on touch, optional autoplay.
   * Autoplay pauses on hover, keyboard focus, touch, a hidden tab, and never runs with reduced motion.
   * Defined as a custom element so it also works after the theme editor re-renders the section.
   */
  (function () {
    if (customElements.get('vaja-reviews')) return;

    class VajaReviews extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.vaja-review'));
        this.dots = Array.from(this.querySelectorAll('[data-go]'));
        this.index = 0;
        if (this.slides.length < 2) return;

        this.delay = Number(this.dataset.autoplay) || 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = false;

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onDown);
        this.addEventListener('pointerup', this.onUp);
        this.addEventListener('pointercancel', this.onCancel);
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(next) {
        const count = this.slides.length;
        this.index = ((next % count) + count) % count;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      }

      start() {
        this.stop();
        if (!this.delay || this.reduced || this.paused) return;
        this.timer = window.setInterval(() => this.go(this.index + 1), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      pause = () => { this.paused = true; this.stop(); };
      resume = () => { this.paused = false; this.start(); };
      onVisibility = () => (document.hidden ? this.stop() : this.start());

      onClick = (event) => {
        const dot = event.target instanceof Element ? event.target.closest('[data-go]') : null;
        if (!dot) return;
        this.go(Number(dot.getAttribute('data-go')));
        this.start();
      };

      onDown = (event) => {
        if (event.pointerType === 'mouse') return;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.stop();
      };

      onCancel = () => {
        this.startX = null;
        this.start();
      };

      onUp = (event) => {
        if (event.pointerType === 'mouse' || this.startX == null) return;
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        this.startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        this.start();
      };
    }

    customElements.define('vaja-reviews', VajaReviews);

    /* Theme editor: selecting a review block shows that review. */
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target instanceof Element ? event.target.closest('.vaja-review') : null;
      const carousel = slide ? slide.closest('vaja-reviews') : null;
      if (!carousel || typeof carousel.go !== 'function') return;
      carousel.pause();
      carousel.go(Number(slide.getAttribute('data-index')));
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const carousel = event.target instanceof Element ? event.target.closest('vaja-reviews') : null;
      if (carousel && typeof carousel.resume === 'function') carousel.resume();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
